export default __webpack_public_path__ + "static/bg-pandas-profiling-b0eb76f9977eccaa8119e2a02aa5af5b.webp";